import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@14.2.0/swiper.min.mjs';
import Scrollbar from 'https://cdn.jsdelivr.net/npm/swiper@14.2.0/modules/scrollbar.min.mjs';

(function () {
  var mobileQuery = window.matchMedia('(max-width: 991px)');

  // Warms every slide in the gallery the moment the swiper initializes.
  // Native loading="lazy" only reliably grabs the first couple of slides
  // once the card scrolls into view (this is a transform-driven carousel,
  // not real scrolling, same underlying issue as the PDP gallery) —
  // anything further along stayed blank until a swipe reached it. A
  // detached Image() bypasses loading="lazy" entirely, so this gets the
  // whole gallery downloading up front instead of one swipe at a time.
  function preloadSlide(img) {
    if (!img || img.dataset.prefetched) return;
    img.dataset.prefetched = 'true';
    var preload = new Image();
    if (img.sizes) preload.sizes = img.sizes;
    if (img.srcset) preload.srcset = img.srcset;
    preload.src = img.src;
  }

  function warmAllSlides(swiper) {
    swiper.slides.forEach(function (slide) {
      preloadSlide(slide.querySelector('img'));
    });
  }

  function initSwiper(el) {
    if (el.dataset.swiperInitialized) return;
    el.dataset.swiperInitialized = 'true';
    var container = el.querySelector('.product-item_swiper');
    if (!container) return;
    new Swiper(container, {
      modules: [Scrollbar],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      threshold: 5,
      resistanceRatio: 0.85,
      scrollbar: {
        el: container.querySelector('.swiper-scrollbar'),
        draggable: false,
      },
      on: {
        init: warmAllSlides,
      },
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (mobileQuery.matches) initSwiper(entry.target);
      });
    },
    { rootMargin: '200px' }
  );

  function observeAll(root) {
    (root || document)
      .querySelectorAll('.product-item_image-swiper:not([data-swiper-initialized])')
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  // Live-resize safety net: if the viewport crosses into the tablet/mobile
  // range after page load (e.g. a merchant testing by dragging the browser
  // window), initialize any card that's already on screen but was skipped
  // because it was observed while still in the desktop range.
  mobileQuery.addEventListener('change', function (e) {
    if (!e.matches) return;
    document
      .querySelectorAll('.product-item_image-swiper:not([data-swiper-initialized])')
      .forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom > -200 && rect.top < window.innerHeight + 200) {
          initSwiper(el);
        }
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    observeAll(document);

    // Defensive: re-scan if the product grid is replaced/appended to (e.g.
    // an AJAX filter refresh), so newly-inserted cards still get a swiper.
    var grid = document.getElementById('filter-feed');
    if (grid) {
      new MutationObserver(function () {
        observeAll(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  });
})();
